export const DEFAULT_ICON_SIZE = 24
export const DEFAULT_ICON_COLOR = 'content-1'
